var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7187 14.4065C23.7812 19.094 20.2469 23.5077 15.2875 24.494C12.8687 24.9757 10.3596 24.682 8.1175 23.6547C5.87536 22.6274 4.01447 20.919 2.7998 18.7726C1.58512 16.6262 1.07859 14.1512 1.35233 11.7002C1.62606 9.24919 2.6661 6.947 4.32437 5.12146C7.72562 1.37521 13.4687 0.343958 18.1562 2.21896",
    stroke: "#7B0003",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 12.5312L13.4688 17.2188L24.7188 5.03125",
    stroke: "#7B0003",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.c082848152b364f4b6a1089ab1dd0936.svg";
export { ForwardRef as ReactComponent };